import { HELP_CENTER_API_PATH } from 'config/urls'

import { interWbHttp } from '@interco/inter-webview-bridge'

export function fetchOmbudsmanCases(): Promise<unknown[]> {
  return interWbHttp
    .get({ endpoint: `${HELP_CENTER_API_PATH}/qualified-ombudsman-cases` })
    .then((res) => JSON.parse(res.response))
}
